<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">
          <img src="/static/img/zortout.png" alt style="max-height: 50px" />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn v-if="!isEdit && step > 1" fab outline small color="primary" @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('register_zortout') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('connect_zortout_service_for_more') }}</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://zortout.com/'"
            target="_blank"
            @click="step = 2"
          >
            {{ $t('register_zortout') }}</v-btn
          >

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="https://blog.zwiz.ai/zortout_ordermanagement/" target="_blank">{{
              $t('how_to_use_zortout')
            }}</a>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('connect_zwiz_with_zortout') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div class="pa-2" style="position: relative" :style="{ 'min-height': '300px' }">
            <div v-if="showCancel" class="mb-2">
              <div>
                {{ $t('enable_disable_zortout') }}
              </div>
              <div>
                <toggle-button
                  class="mt-2"
                  :value="setting.is_active"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                  @change="toggleStatus"
                />
              </div>
            </div>
            <template v-if="isEdit">
              <div class="caption">{{ $t('store_name') }}</div>
              <div class="form-control" :class="{ 'has-error': errors.has('store_name') }">
                <template>
                  <input
                    v-model="setting.store_name"
                    v-validate="''"
                    type="text"
                    name="setting.store_name"
                    data-vv-as="store_name"
                  />
                  <span v-if="errors.has('setting.store_name')" class="text-error">{{
                    errors.first('setting.store_name')
                  }}</span>
                </template>
              </div>

              <div class="caption">api key</div>
              <div class="form-control" :class="{ 'has-error': errors.has('api_key') }">
                <template>
                  <input
                    v-model="setting.api_key"
                    v-validate="''"
                    type="text"
                    name="setting.api_key"
                    data-vv-as="api_key"
                  />
                  <span v-if="errors.has('setting.api_key')" class="text-error">{{
                    errors.first('setting.api_key')
                  }}</span>
                </template>
              </div>

              <div class="caption">api secret</div>
              <div class="form-control" :class="{ 'has-error': errors.has('api_secret') }">
                <template>
                  <input
                    v-model="setting.api_secret"
                    v-validate="''"
                    type="text"
                    name="setting.api_secret"
                    data-vv-as="api_secret"
                  />
                  <span v-if="errors.has('setting.api_secret')" class="text-error">{{
                    errors.first('setting.api_secret')
                  }}</span>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="caption">{{ $t('store_name') }}</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.store_name ? setting.store_name : '-' }}
              </div>

              <div class="caption">api key</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.api_key ? setting.api_key : '-' }}
              </div>

              <div class="caption">api secret</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.api_secret ? setting.api_secret : '-' }}
              </div>

              <v-btn color="primary" outline @click="getZortoutToken()">Generate Token</v-btn>
              <template v-if="zortoutToken">
                <div class="caption">Token</div>
                <div class="primary--text">
                  {{ zortoutToken }}
                </div>
              </template>
            </template>
            <div v-if="isEdit" class="text-xs-center">
              <v-btn
                v-if="showCancel"
                color="grey"
                outline
                :loading="loading"
                @click="isEdit = false"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="primary" depressed :loading="loading" @click="onSave">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import zortoutApi from '@/api/zortout.js'
import summitApi from '@/api/summit'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      zortoutToken: null,
      setting: {
        is_active: false,
        store_name: null,
        api_key: null,
        api_secret: null,
        endpoint_url: 'https://api.zortout.com/api.aspx',
        api_version: '3'
      },
      showCancel: true,
      step: 1
    }
  },
  async mounted() {
    this.getZortout()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async getZortout() {
      try {
        const data = {
          pageid: this.selectedBot.pageid
        }
        const response = await zortoutApi.getZortout({ data })
        if (response.data.message == 'SUCCESS') {
          this.setting.api_key = response.data.result[0].api_key
          this.setting.api_secret = response.data.result[0].api_secret
          this.setting.store_name = response.data.result[0].store_name
          this.setting.is_active = response.data.result[0].is_active
          this.zortoutToken = response.data.result[0].general_token
        }
        if (response.data.result) {
          this.step = 2
        }
      } catch (error) {
        console.error(error)
      }
    },
    async putZortout(setting) {
      try {
        this.$store.dispatch('loading')
        const data = {
          pageid: this.selectedBot.pageid,
          body: setting
        }
        const response = await zortoutApi.putZortout({ data })
        if (response.data.message == 'SUCCESS') {
          this.isEdit = false
        } else {
          this.setting.is_active = !this.setting.is_active
        }
        this.$store.dispatch('loading')
      } catch (error) {
        console.log(error)
        this.$store.dispatch('loading')
        this.setting.is_active = !this.setting.is_active
        await this.$swal({
          title: this.$t('warning_connect_account'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    onSave() {
      this.putZortout(this.setting)
    },
    async toggleStatus() {
      this.setting.is_active = !this.setting.is_active
      this.putZortout(this.setting)
    },
    async getZortoutToken() {
      const data = {
        pageid: this.selectedBot.pageid
      }
      const response = await zortoutApi.getZortoutToken({ data })
      if (response.data.message == 'SUCCESS') {
        this.zortoutToken = response.result.general_token
      }
      if (response.result) {
        this.step = 2
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ZortOutManage.vue